
import { mapGetters } from "vuex";
import { metaGenerator } from "~/utils";
import RegisterForm from "~/components/pages/login/RegisterForm.vue";
import SocialAuth from "~/components/shared/SocialAuth/SocialAuth.vue";
import useEvents from "~/mixins/useEvents";

export default {
  name: "SignUp",
  components: { SocialAuth, RegisterForm },
  mixins: [useEvents],
  middleware: ["guest"],
  async asyncData({ $api, error }) {
    const getPage = async () => {
      try {
        const { data } = await $api.pages.getPage("sign-up");
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
        error({ statusCode: err.response.status });
      }
    };
    return {
      pageData: await getPage(),
    };
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: true,
    });
    const titleTemplate = `%s | ${this.getCompanyName}`;
    return {
      meta: [
        ...metaGenerator({
          title:
            this.pageData?.mixedTranslation?.meta_title ||
            this.pageData?.mixedTranslation?.title ||
            "",
          description: this.pageData?.mixedTranslation?.meta_description || "",
          image:
            this.pageData?.medias?.find((el) => el.position === "open-graph")
              ?.file?.url || "",
          url:
            this.pageData?.mixedTranslation?.meta_url ||
            process.env.DOMAIN + this.$route.fullPath,
          company_name: this.getCompanyName,
          titleTemplate,
        }),
        ...i18nHead.meta,
      ],
      htmlAttrs: i18nHead.htmlAttrs,
      link: i18nHead.link,
      title:
        this.pageData?.mixedTranslation?.meta_title ||
        this.pageData?.mixedTranslation?.title ||
        "",
      titleTemplate,
    };
  },
  computed: {
    ...mapGetters({
      getCompanyName: "general/getCompanyName",
      userInfo: "auth/getUserInfo",
      getFirebaseIntegration: "general/getFirebaseIntegration",
    }),
  },
  mounted () {
    this.visitEvent();
  },
  methods: {
    async onSocialAuthSuccess(event) {
      if (event.userData && event.userData.action === "register") {
        this.$alert({
          title: `${this.$t("success")}!`,
          text: `${this.$t("yourAccountHasBeenSuccessfullyCreated")}.`,
          successHandler: () => {
            this.$router.replace(
              this.localePath(this.$route.query.redirect || "/")
            );
          },
        });
      } else {
        await this.$router.replace(
          this.localePath(this.$route.query.redirect || "/")
        );
      }
    },
  },
};
